import { ReplyType } from './services/lessons-reader.model';
import { Alternative, Content } from './undergrad-content.model';
import { UnifiedCommentModel } from '../UnifiedCommentModel';
import { Solution } from './undergrad-solution.model';

export enum LessonType {
  AULA_GRAVADA = 'AULA_GRAVADA',
  TUTORIA = 'TUTORIA',
  APRESENTACAO = 'APRESENTACAO',
}

export enum LessonItemType {
  EXERCISE = 'Exercise',
  ARTICLE = 'Article',
  VIDEO = 'Video',
}

export enum ExerciseType {
  DISCURSIVE = 'PENSAR_RESPONDER',
  OBJECTIVE = 'MULTIPLE_CHOICE',
  PRACTICE = 'ATIVIDADE_PRATICA',
  OBJECTIVE_TRIVIA = 'PENSAR_RESPONDER_OBJETIVO',
}

export enum ExerciseTypeTracking {
  'PENSAR_RESPONDER' = 'trivia',
  'MULTIPLE_CHOICE' = 'exercise',
  'ATIVIDADE_PRATICA' = 'practice',
  'PENSAR_RESPONDER_OBJETIVO' = 'objectiveThinkAndAnswer',
}

export abstract class LessonItem {
  id: string;

  lessonItemType: LessonItemType;

  name: string;

  isVideo() {
    return this.lessonItemType === LessonItemType.VIDEO;
  }

  isExercise() {
    return this.lessonItemType === LessonItemType.EXERCISE;
  }

  isArticle() {
    return this.lessonItemType === LessonItemType.ARTICLE;
  }
}

export class Exercise extends LessonItem {
  type: ExerciseType;

  dexExerciseId: number;

  contents: Content[];

  comments?: UnifiedCommentModel[];

  replies?: ReplyType[];

  solutions?: Solution[];

  alternatives?: Alternative[];

  isDiscursive() {
    return this.type === ExerciseType.DISCURSIVE || this.type === ExerciseType.OBJECTIVE_TRIVIA;
  }

  isObjective() {
    return this.type === ExerciseType.OBJECTIVE;
  }

  isPractice() {
    return this.type === ExerciseType.PRACTICE;
  }
}

export class Article extends LessonItem {
  dexArticleId: number;

  contents: Content[];
}

export class Video extends LessonItem {
  youtubeId: string;

  kalturaId: string;

  durationInSeconds: number;
}

export interface UndergradLesson {
  id: string;
  name: string;
  description?: string;
  subject?: string;
  slug: string;
  type: LessonType;
  items?: LessonItem[];
  updatedAt?: Date;
}
